import { mapState } from 'vuex';

/**
 * Product Gallery component
 */
export default {
  components: {
    'vue-image': () => import('../vue-image/vue-image.vue'),
    'vue-image-v2': () => import('../vue-image-v2/vue-image-v2.vue'),
  },
  props: ['initialIndex'],
  data() {
    return {
      activeIndex: this.initialIndex,
    };
  },
  computed: {
    ...mapState('product', ['product']),
    featured() {
      if (!this.product?.media.length) return false;
      return this.product.media[this.activeIndex];
    },
    thumbsContainerWidth() {
      return `${17 * this.product.media.length}vw`;
    },
  },
  methods: {
    toggle() {
      this.$emit('toggle');
    },
    setIndex(index) {
      this.activeIndex = index;
    },
  },
};
